import { render, staticRenderFns } from "./start-course-page.html?vue&type=template&id=f332442e&"
import script from "./start-course-page.ts?vue&type=script&lang=ts&"
export * from "./start-course-page.ts?vue&type=script&lang=ts&"
import style0 from "./start-course-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports